import React from 'react';
import PropTypes from 'prop-types';
import { lifecycle } from 'recompose';
import { isEqual } from 'lodash';

import { Select as SharedSelect } from 'shared/components';
import requestStatuses from 'modules/common/constants/requestsStatuses';

import { isErrorCode, checkErrorStatus } from './checkError';

const propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    iconName: PropTypes.string,
  })),
  errorMessagesMap: PropTypes.object,
  placeholder: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  label: PropTypes.object,
  rootClassName: PropTypes.string,
  tooltipSize: PropTypes.string,
  tooltipMessage: PropTypes.object,
  viewportRef: PropTypes.func,
};

const defaultProps = {
  items: [],
  errorMessagesMap: {},
  placeholder: undefined,
  label: null,
  rootClassName: '',
  tooltipSize: 'medium',
  tooltipMessage: null,
  viewportRef: null,
};

const Select = (props) => {
  const {
    input,
    meta: { error },
    items,
    errorMessagesMap,
    ...rest
  } = props;

  const errorMessage = !isErrorCode(error)
    ? { defaultMessage: error, id: 'default' }
    : error && errorMessagesMap[error];

  const currItem = items.find(item => item.key === input.value);

  return (
    <SharedSelect
      { ...input }
      { ...rest }
      items={ items }
      testId={ input.name }
      status={ checkErrorStatus(props.meta)
        ? requestStatuses.failure
        : requestStatuses.default
      }
      tooltipMessage={ checkErrorStatus(props.meta) ? errorMessage : null }
      maxLength={ (rest && rest.maxLength) || 200 }
      onChange={ ({ key }) => { input.onChange(key); } }
      selectedItem={ currItem || null }
    />
  );
};

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export default lifecycle({
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.input, nextProps.input)
      || !isEqual(this.props.meta, nextProps.meta)
      || this.props.items !== nextProps.items
      || this.props.disabled !== nextProps.disabled
      || this.props.loading !== nextProps.loading;
  },
})(Select);
